
<!-- ======= Header ======= -->
<header id="header" class="fixed-top">
	<div class="container  align-items-center">
	  <div class="row">
		<div class="col-xs-6 col-sm-6 col-md-6 col-lg-6">
		<h1 class="logo mr-auto img-responsive fl mt"><a href="https://www.hdfcbank.com/" target="_blank"><img src="./assets/images/landing-img/Dao2In1_1/hdfcbank1.png" class="mmlogo1" alt="HDFC Bank " ></a></h1>
		  
		</div>
		<div class="col-xs-6 col-sm-6 col-md-6 col-lg-6">
		<h1 class="logo mr-auto img-responsive fr mt "><a href="https://www.hdfcsec.com/" target="_blank"><img src="./assets/images/landing-img/Dao2In1_1/hsl_logo.png" class="mmlogo" alt="HDFC securities." ></a></h1>
		  
		</div>
		<div class="clearfix"></div>
		
	  </div>
	</div>
   
  </header>
  <!-- End Header -->
  
  <main id="main">
	<section class="bgmain">
	 <div class="container">
		<div class="row">
		
		  <div class="col-sm-12 col-md-12 col-lg-12 wow fadeInDown" data-wow-delay="300ms">
		   
			<h1 class="open">Open Demat &amp; Trading Account in just 10 mins*</h1>
			
			
		   
		  </div>
		  <div class="clearfix"></div>
			 
			
		  <div class="col-lg-12 col-md-12 col-sm-12  wow fadeInDown" data-wow-delay="300ms" > 
			  <img class="img-responsive intro" alt="₹20 Per trade for derivatives investment 3in1 Account Experience the joy of seamless investing,Free Demat AMC for first year. Enjoy max capping of ₹4999 on demat debit transaction cost. (Min. is ₹30)" src="./assets/images/landing-img/Dao2In1_1/women2.jpg" data-holder-rendered="true" style="margin:0 auto;"> </div>
	  
	  </div>
	   <div class="row">
	   
	  <div class="col-lg-12 col-md-12 col-sm-12 wow fadeInDown" data-wow-delay="300ms"  > 
	   <div class="  formb">
	   <div class="col-lg-12 col-md-12 col-sm-12 text-center formcontainer"  > 
	   <div  class="fixme">
		<fieldset id="eotp">
	  <form class="form-inline" action="#" style="display:block;">
   <div class="form-group">
	  <input type="text" class="form-control" id="email" placeholder="Enter your 10 digit mobile no." id="txtMobile" name="txtMobile" [(ngModel)]="loginDetails.Mobile" maxlength="10" onkeypress="return !isNaN(event.key) || event.charCode == 13" autocomplete="off" />
	
	  <button type="submit" class="btn btn-danger btn-lg startj" (click)="doLogin()">Open an Account</button>
	  </div>
	  <div class="form-group form-group-checkbox mb10">
		
		<label for="chkTerms">
			
			<div class="pl17">
				<p class="p-15 mt5 text-black3">
					<input type="checkbox" id="chkTerms" name="chkTerms" class="input-check-box"
			   [(ngModel)]="agreeTerms">
					I agree to <a class="btn common-link2 text-hdfc-blue"
href="#modal-term-condition" data-toggle="modal"
target="_blank">Terms & Conditions</a>
				</p>
			</div>
		</label>
	</div>
	  </form>
	  </fieldset>
	  <fieldset id="otpdiv" style="display: none;">
	  <form class="form-inline" action="#" style="display:block;">
	  <div class="form-group">
  <p>6 digit code has been sent via SMS on <br>******7095 &amp; email on dum******u@gmail.com</p> 
	 </div>
	 
   <div class="form-group">
	 
	  <input type="text" class="form-control" id="OTP" placeholder="Enter your OTP" maxlength="6"  pattern="\d{6}"  required="">  
	   
	  <button type="submit" class="btn btn-danger btn-lg startj">Verify OTP</button>
	  </div>
	  <div class="form-group">
	  <div class="errorBlock FULoginID">
		<a href="#" >Back</a> | <a href="#" >Resend OTP</a>
										
										  </div>
										  </div>
	  </form>
  
		  </fieldset>
	  <div class="col-lg-12 mt-2 text-center">
			<!-- <h5 class="note">Note: This journey is for regular DEMAT Account. For BSDA (Basic Services Demat Account). Kindly proceed with physical application at your nearest branch. <br> The account will be opened basis details fetched from KRA/Digi-locker. In case there is any change in address updated with KRA/Digi-locker, kindly proceed with physical application at your nearest branch </h5>   -->
		</div>
	  </div>
	  </div>
	  </div>
  </div>
  </div>
  </div>
	</section>
	<!-- End Breadcrumbs -->
  
  
	<section>
	 
	 
	  <div class="container">
	  <div class="row wow fadeInUp hdfcad" data-wow-delay="500ms">
	
			<div class="col-lg-12 md-12 mt-2 text-center wow fadeInUp" data-wow-delay="900ms">
			<a href="https://www.hdfcbank.com/personal/invest/demat/open-demat-account/fees-and-charges" target="_blank">
		   <img class="img-responsive " alt="HDFC securities advantage and Trusted legacy for 20+ Years"  src="./assets/images/landing-img/Dao2In1_1/hsladvantage.jpg" data-holder-rendered="true" style="margin:10 auto;">
		   </a>
		  </div>
		  
		  
	  
	  
	   </div>
	   <div class="row wow fadeInUp hdfcad1" data-wow-delay="500ms">
	   <div class="col-lg-12  mt-2 text-center">
			
			  <h2 class="dta1"><span style="color:#024289;">HDFC Advantage</span></h2>
			  <div class="bl1"></div>
			   <h4 class="fdta text-center"> Trusted legacy for
  25 Years </h4>
		  </div>
			  <div class="col-lg-12 mt-2 text-center">
		<div class="row">
		  <div class="col-lg-3 col-md-3 col-sm-6 text-center wow fadeInUp" data-wow-delay="700ms"> <img class="img-responsive " alt="360° Investment Solutions" src="./assets/images/landing-img/Dao2In1_1/IS.png" data-holder-rendered="true" style="margin:0 auto;">
			<h3 class="hdfcadvantagth"><span>360° Investment Solutions </span><br/>
  Equity | Derivatives | ETFs
  Fixed Income | Mutual Funds
  </h3>
		  </div>
		  <div class="col-lg-3 col-md-3 col-sm-6 text-center wow fadeInUp" data-wow-delay="800ms"> <img class="img-responsive " alt="Research Expertise
  releas" src="./assets/images/landing-img/Dao2In1_1/RE.png" data-holder-rendered="true" style="margin:0 auto;">
			 <h3 class="hdfcadvantagth"><span>Research Expertise</span> by HDFC securities Dedicated &amp; experienced team of research Experts
  </h3>
		  </div>
		  <div class="col-lg-3 col-md-3 col-sm-6 text-center wow fadeInUp" data-wow-delay="900ms" > <img class="img-responsive " alt="Nearest DP branch" src="./assets/images/landing-img/Dao2In1_1/DPB.png" data-holder-rendered="true" style="margin:0 auto;">
			 <h3 class="hdfcadvantagth">Get offline support from <span>4000+ HDFC Bank</span> branches. Find the live location of the nearest branch by typing "Nearest DP branch" on WhatsApp
  number-<b>70659 70659</b></h3>
		  </div>
			<div class="col-lg-3 col-md-3 col-sm-6 text-center wow fadeInUp" data-wow-delay="1000ms" > <img class="img-responsive " alt="Digital Loans" src="./assets/images/landing-img/Dao2In1_1/DL.png" data-holder-rendered="true" style="margin:0 auto;">
			 <h3 class="hdfcadvantagth">Avail <span>Digital Loans</span> against Securities and Mutual Funds with HDFC Bank</h3>
		  </div>
		  <div class="col-lg-3 col-md-3 col-sm-6 text-center wow fadeInUp" data-wow-delay="1100ms" > <img class="img-responsive " alt="NetBanking" src="./assets/images/landing-img/Dao2In1_1/NB.png" data-holder-rendered="true" style="margin:0 auto;">
			 <h3 class="hdfcadvantagth">Track your investments and statements via <span>NetBanking</span></h3>
		  </div>
		  <div class="col-lg-3 col-md-3 col-sm-6 text-center wow fadeInUp" data-wow-delay="1200ms" > <img class="img-responsive " alt="No hassle of fund transfer" src="./assets/images/landing-img/Dao2In1_1/FT.png" data-holder-rendered="true" style="margin:0 auto;">
			 <h3 class="hdfcadvantagth">Instantly redeem investment returns to your HDFC Bank account. <span>No hassle of fund transfer</span>. Earn Savings Account interest till your trade order is executed.
  </h3>
		  </div>
		  <div class="col-lg-3 col-md-3 col-sm-6 text-center wow fadeInUp" data-wow-delay="1300ms"> <img class="img-responsive " alt="Preferential pricing and discounts" src="./assets/images/landing-img/Dao2In1_1/TP.png" data-holder-rendered="true" style="margin:0 auto;">
			 <h3 class="hdfcadvantagth"><span>Preferential pricing and discounts</span> on AMC &amp; transactions for our Premier Banking customers. Know detailed tariff <a href="https://www.hdfcbank.com/personal/invest/demat/open-demat-account/fees-and-charges" target="_blank" style="text-decoration:underline;">here</a></h3>
		  </div>
		  <div class="col-lg-3 col-md-3 col-sm-6 text-center wow fadeInUp" data-wow-delay="1400ms" style="visibility: visible; animation-delay: 900ms; animation-name: fadeInUp;"> <img class="img-responsive " alt="Call & Trade" src="./assets/images/landing-img/Dao2In1_1/CT.png" data-holder-rendered="true" style="margin:0 auto;">
			 <h3 class="hdfcadvantagth"><span>Call &amp; Trade</span> at Zero cost</h3>
		  </div>
		</div>
		</div>
	   </div>
	  <br/>
		<hr/> 
			 <br/>
	  
		<div class="row wow fadeInUp" data-wow-delay="500ms">
	   
		  <div class="col-lg-12  mt-2 text-center">
			
			  <h2 class="dta1"><span style="color:#024289;">Plans that suit your Trading style</span></h2>
			  <div class="bl1"></div>
			   <h4 class="fdta text-center"> Futures and Options  &#8377;20 per order  |  &#8377;5 Lacs same day payout without additional cost </h4>
		  </div>
		</div>
	  
	  
		<div class="row">
		 <div class="col-lg-12 md-12 mt-2 text-center wow fadeInUp" data-wow-delay="600ms">
		   <img class="img-responsive vplans" alt="Plans that suit your Trading style"  src="./assets/images/landing-img/Dao2In1_1/plan.png" data-holder-rendered="true" style="margin:0 auto;">
	   </div>
	   </div>
  
	   <div class="row wow fadeInUp" data-wow-delay="500ms">
		 <div class="col-lg-12 mb-12 mt-2 text-center mobile wow fadeInUp" data-wow-delay="600ms">
			  <h3 class="planimgtxtAM">&#x2B50;Most Subscribed
  </h3>
			  <!-- <div class="table mobile-accordion table-borderless">
				<div class="thead">
					  <div class="tr">
							
												<div class="th planH">Scheme Name</div>
												 <div class="th planH">Value Plan Charges</div>
												<div class="th planH">Free Equity Delivery Volume**</div>
												<div class="th planH">Free Equity Delivery Volume Validity##</div>
												<div class="th planH">Equity Delivery</div>
												<div class="th planH">Equity Intraday</div>
												<div class="th planH">Options <br/>(Per Order)</div>
						  <div class="th planH"  style="border-right: 0px;">Futures <br/>(Per Order)</div>
  
					  </div>
				</div>
				<div class="tbody">
					  <div class="rh active"><span class="pl">Traders Delight: <br/>Value 20</span></div>
					  <div class="tr">
											  <div class="td plantxt" data-header="Value Plan Charges:"> ₹50,000</div>
												 <div class="td plantxt" data-header="Free Equity Delivery Volume**:"> ₹4 Crs</div>
												  <div class="td plantxt" data-header="Free Equity Delivery Volume Validity##:"> 360 days</div>
												<div class="td plantxt" data-header="Equity Delivery:">0.20%</div>
												<div class="td plantxt" data-header="Equity Intraday:">0.020%</div>
												<div class="td plantxt" data-header="Options (Per Order):">₹20</div>
												<div class="td plantxt" style="border-right: 0px;"  data-header="Futures (Per Order):">₹20</div>
											   
					  </div>
					 <div class="rh"><span>Traders Delight :<br/>Value 25&#x2B50;</span></div>
					  <div class="tr">
											  
												 <div class="td plantxt" data-header="Value Plan Charges:"> ₹25,000</div>
												 <div class="td plantxt" data-header="Free Equity Delivery Volume**:"> ₹1.5 Crs</div>
												  <div class="td plantxt" data-header="Free Equity Delivery Volume Validity##:"> 360 days</div>
												<div class="td plantxt" data-header="Equity Delivery:">0.25%</div>
												<div class="td plantxt" data-header="Equity Intraday:">0.025%</div>
												<div class="td plantxt" data-header="Options (Per Order):">₹20</div>
												<div class="td plantxt" style="border-right: 0px;"  data-header="Futures (Per Order):">₹20</div>
					  </div>
					  <div class="rh "><span>Investors Choice:<br/>Alpha 4999</span></div>
					  <div class="tr">
											  
												 <div class="td plantxt" data-header="Value Plan Charges:"> ₹4,999</div>
												 <div class="td plantxt" data-header="Free Equity Delivery Volume**:"> ₹2 Lacs</div>
												  <div class="td plantxt" data-header="Free Equity Delivery Volume Validity##:"> 30 days</div>
												<div class="td plantxt" data-header="Equity Delivery:">0.10%</div>
												<div class="td plantxt" data-header="Equity Intraday:">0.010%</div>
												<div class="td plantxt" data-header="Options (Per Order):">₹20</div>
												<div class="td plantxt" style="border-right: 0px;"  data-header="Futures (Per Order):">₹20</div>
					  </div>
					<div class="rh "><span>Investors Choice:<br/>Alpha 2999&#x2B50;</span></div>
					  <div class="tr">
											  
												  <div class="td plantxt" data-header="Value Plan Charges:"> ₹2,999</div>
												 <div class="td plantxt" data-header="Free Equity Delivery Volume**:"> ₹1.5 Lacs</div>
												  <div class="td plantxt" data-header="Free Equity Delivery Volume Validity##:"> 30 days</div>
												<div class="td plantxt" data-header="Equity Delivery:">0.15%</div>
												<div class="td plantxt" data-header="Equity Intraday:">0.015%</div>
												<div class="td plantxt" data-header="Options (Per Order):">₹20</div>
												<div class="td plantxt" style="border-right: 0px;"  data-header="Futures (Per Order):">₹20</div>
					  </div>
				  
					   <div class="rh "><span>Starter Pack:<br/>Lite 999</span></div>
					  <div class="tr">
											  
												 <div class="td plantxt" data-header="Value Plan Charges:"> ₹999</div>
												 <div class="td plantxt" data-header="Free Equity Delivery Volume**:"> ₹75,000</div>
												  <div class="td plantxt" data-header="Free Equity Delivery Volume Validity##:"> 30 days</div>
												<div class="td plantxt" data-header="Equity Delivery:">0.22%</div>
												<div class="td plantxt" data-header="Equity Intraday:">0.022%</div>
												<div class="td plantxt" data-header="Options (Per Order):">₹20</div>
												<div class="td plantxt" style="border-right: 0px;"  data-header="Futures (Per Order):">₹20</div>
					  </div>
					   <div class="rh "><span>Starter Pack:<br/>Lite 299 &#x2B50; </span></div>
					  <div class="tr">
											  
												 <div class="td plantxt" data-header="Value Plan Charges:"> ₹299</div>
												 <div class="td plantxt" data-header="Free Equity Delivery Volume**:"> ₹50,000</div>
												  <div class="td plantxt" data-header="Free Equity Delivery Volume Validity##:"> 30 days</div>
												<div class="td plantxt" data-header="Equity Delivery:">0.27%</div>
												<div class="td plantxt" data-header="Equity Intraday:">0.027%</div>
												<div class="td plantxt" data-header="Options (Per Order):">₹20</div>
												<div class="td plantxt" style="border-right: 0px;"  data-header="Futures (Per Order):">₹20</div>
					  </div>
					   <div class="rh "><span>Starter Pack:<br/>Lite 199</span></div>
					  <div class="tr">
											  
												 <div class="td plantxt" data-header="Value Plan Charges:"> ₹199</div>
												 <div class="td plantxt" data-header="Free Equity Delivery Volume**:"> ₹25,000</div>
												  <div class="td plantxt" data-header="Free Equity Delivery Volume Validity##:"> 30 days</div>
												<div class="td plantxt" data-header="Equity Delivery:">0.32%</div>
												<div class="td plantxt" data-header="Equity Intraday:">0.032%</div>
												<div class="td plantxt" data-header="Options (Per Order):">₹20</div>
												<div class="td plantxt" style="border-right: 0px;"  data-header="Futures (Per Order):">₹20</div>
					  </div>
				</div>
		  </div> -->
			
		  <div class="table mobile-accordion table-borderless">
			<div class="thead">
				  <div class="tr">
						
											<div class="th planH">AOC Charges (exculsive GST)</div>
											 <div class="th planH">Free Cash Volume (₹) for 90 days </div>
											<div class="th planH"> Delivery Brokerage % </div>
											<div class="th planH">Intraday Brokerage % </div>
											<div class="th planH">Minimum Brokerage</div>
											<div class="th planH">Buy Stock Pay Later </div>
											<div class="th planH">Derivatives <br/>(Per Order)</div>
					  <div class="th planH"  style="border-right: 0px;">Demat AMC</div>

				  </div>
			</div>
			<div class="tbody">
				  <div class="rh active"><span class="pl">Platina : <br/> </span>
					  <p style="font-size: 14px; padding: 0px 35px;">Infinity/Imperia / Speciale platinum /MAMC/Speciale Sr. Citizen </p></div>
				  <div class="tr">
										  <div class="td plantxt" data-header="AOC Charges (exculsive GST)"> 0</div>
											 <div class="td plantxt" data-header="Free Cash Volume (₹) for 90 days "> ₹25,00,000 </div>
											  <div class="td plantxt" data-header="Delivery Brokerage %"> 0.10%</div>
											<div class="td plantxt" data-header="Intraday Brokerage %">0.01%</div>
											<div class="td plantxt" data-header="Minimum Brokerage">10</div>
											<div class="td plantxt" data-header="Buy Stock Pay Later">14%</div>
					  <div class="td plantxt" data-header="Derivatives (Per Order)">₹20</div>
											<div class="td plantxt" style="border-right: 0px;"  data-header="Demat AMC">Life Time Free</div>
										   
				  </div>
				 <div class="rh"><span>Premia :<br/> </span>
				<p style="font-size: 14px; padding: 0px 35px;">Preferred/Speciale Gold </p>
				</div>
				  <div class="tr">
										  <div class="td plantxt" data-header="AOC Charges (exculsive GST)"> 0</div>
											 <div class="td plantxt" data-header="Free Cash Volume (₹) for 90 days "> ₹12,00,000 </div>
											  <div class="td plantxt" data-header="Delivery Brokerage %"> 0.15%</div>
											<div class="td plantxt" data-header="Intraday Brokerage %">0.015%</div>
											<div class="td plantxt" data-header="Minimum Brokerage">15</div>
											<div class="td plantxt" data-header="Buy Stock Pay Later">16%</div>
					  <div class="td plantxt" data-header="Derivatives (Per Order)">₹20</div>
											<div class="td plantxt" style="border-right: 0px;"  data-header="Demat AMC">Free <br/><span style="font-size: 10px;">(1 Txn p.a @ Demat AMC of 750 waived off) or 300 for Nil TXN </span></div>
										   
				  </div>
				  <div class="rh "><span>Maxima</span>
				<p style="font-size: 14px; padding: 0px 35px;">Classic /Prime / SB Max  </p>
				</div>
				  <div class="tr">
										  <div class="td plantxt" data-header="AOC Charges (exculsive GST)"> 0</div>
											 <div class="td plantxt" data-header="Free Cash Volume (₹) for 90 days "> ₹5,00,000 </div>
											  <div class="td plantxt" data-header="Delivery Brokerage %"> 0.20%</div>
											<div class="td plantxt" data-header="Intraday Brokerage %">0.02%</div>
											<div class="td plantxt" data-header="Minimum Brokerage">20</div>
											<div class="td plantxt" data-header="Buy Stock Pay Later">18%</div>
					  <div class="td plantxt" data-header="Derivatives (Per Order)">₹20</div>
											<div class="td plantxt" style="border-right: 0px;"  data-header="Demat AMC">66% Off<br/><span style="font-size: 10px;float: right;">(1 Txn p.a -Pay only ₹250  or ₹500 for Nil Txn) </span></div>
										   
				  </div>
				<div class="rh "><span>Optima</span>
				<p style="font-size: 14px; padding: 0px 35px;">Non Managed / Others   </p>
				</div>
				 <div class="tr">
										  <div class="td plantxt" data-header="AOC Charges (exculsive GST)"> ₹199</div>
											 <div class="td plantxt" data-header="Free Cash Volume (₹) for 90 days "> ₹2,00,000 </div>
											  <div class="td plantxt" data-header="Delivery Brokerage %"> 0.30%</div>
											<div class="td plantxt" data-header="Intraday Brokerage %">0.03%</div>
											<div class="td plantxt" data-header="Minimum Brokerage">25</div>
											<div class="td plantxt" data-header="Buy Stock Pay Later">18%</div>
					  <div class="td plantxt" data-header="Derivatives (Per Order)">₹20</div>
											<div class="td plantxt" style="border-right: 0px;"  data-header="Demat AMC">33% Off<br/><span style="font-size: 10px;float: right;">(1 Txn p.a -Pay only ₹500  or ₹750 for Nil Txn) </span></div>
										   
				  </div>
			   
			</div>
	  </div>  
	   </div>
		  </div>
			   <div class="row wow fadeInUp" data-wow-delay="600ms">
		<div class="col-lg-2 col-md-2 col-sm-12 text-center wow fadeInUp" data-wow-delay="600ms">
				 
		  
		  </div> 
				 <div class="col-lg-5 col-md-5 col-sm-12 text-center wow fadeInUp" data-wow-delay="600ms">
				 
			<h3 class="planimgtxtA">&#x2B50;Most Subscribed
  </h3>
		  </div>  
		   <div class="col-lg-5 col-md-5 col-sm-12 text-center wow fadeInUp" data-wow-delay="600ms"> 
			<h3 class="planimgtxtB">For Terms and Conditions, <a href="./assets/Pdf/VPTCNew.pdf" target="_blank" style="text-decoration:underline;">click here</a>.
  </h3>
		  </div>  
		  </div>
		  </div>
		  
	  
	</section>
  
  
  
  
  
  
  
  
	  <section>	
	
		  
	  <div class="container">
	  
	  
	  
		<div class="row wow fadeInUp" data-wow-delay="500ms">
		  <div class="col-lg-12 mb-4 mt-2 text-center">
			<h2 class="dta">Your Investment Account &amp; Endless Opportunities!!!</h2>
			<div class="bl1"></div>
		  </div>
			</div>
		  <div class="row wow fadeInUp bproundA" data-wow-delay="700ms">
			 <div class="col-lg-3 col-md-3 col-sm-6 text-center wow fadeInUp" data-wow-delay="700ms"> <img class="img-responsive bproimgA " src="./assets/images/landing-img/Dao2In1_1/stockipo.png" alt="Stocks & IPOs" style="margin:0 auto;">
			<h3 class="bproimgtxtA">Stocks &amp; IPOs
  </h3>
		  </div>
		   <div class="col-lg-3 col-md-3 col-sm-6 text-center wow fadeInUp" data-wow-delay="700ms"> <img class="img-responsive bproimgA " src="./assets/images/landing-img/Dao2In1_1/FO.png" alt="Futures
  & Option" style="margin:0 auto;">
			<h3 class="bproimgtxtA">Futures
  &amp; Options
  </h3>
		  </div>
		   <div class="col-lg-3 col-md-3 col-sm-6 text-center wow fadeInUp" data-wow-delay="700ms"> <img class="img-responsive bproimgA " src="./assets/images/landing-img/Dao2In1_1/MTF.png" alt="Buy Now, Pay
  Later With MTF" style="margin:0 auto;">
			<h3 class="bproimgtxtA">Buy Now, Pay
  Later With MTF
  </h3>
		  </div>
		   <div class="col-lg-3 col-md-3 col-sm-6 text-center wow fadeInUp" data-wow-delay="700ms"> <img class="img-responsive bproimgA " src="./assets/images/landing-img/Dao2In1_1/CD.png" alt="Currency &
  Commodities" style="margin:0 auto;">
			<h3 class="bproimgtxtA">Currency &amp;
  Commodities
  </h3>
		  </div>
		   <div class="col-lg-3 col-md-3 col-sm-6 text-center wow fadeInUp" data-wow-delay="700ms"> <img class="img-responsive bproimgA " src="./assets/images/landing-img/Dao2In1_1/BASKET.png" alt="Basket
  Investing" style="margin:0 auto;">
			<h3 class="bproimgtxtA">Basket
  Investing
  </h3>
		  </div>
		   <div class="col-lg-3 col-md-3 col-sm-6 text-center wow fadeInUp" data-wow-delay="700ms"> <img class="img-responsive bproimgA " src="./assets/images/landing-img/Dao2In1_1/SLBM.png" alt="SLBM" style="margin:0 auto;">
			<h3 class="bproimgtxtA">SLBM
  </h3>
		  </div>
		   <div class="col-lg-3 col-md-3 col-sm-6 text-center wow fadeInUp" data-wow-delay="700ms"> <img class="img-responsive bproimgA " src="./assets/images/landing-img/Dao2In1_1/MF.png" alt="Mutual Funds
  & ETFs" style="margin:0 auto;">
			<h3 class="bproimgtxtA">Mutual Funds
  &amp; ETFs
  </h3>
		  </div>
		   <div class="col-lg-3 col-md-3 col-sm-6 text-center wow fadeInUp" data-wow-delay="700ms"> <img class="img-responsive bproimgA " src="./assets/images/landing-img/Dao2In1_1/BUYUS.png" alt="Buy
  US Stocks" style="margin:0 auto;">
			<h3 class="bproimgtxtA">Buy
  US Stocks
  </h3>
		  </div>
		</div>
	  
	  </div>
  
		</section>
	  
	  
	  <section>	
	
		  
	  <div class="container">
	  
		<div class="row">
		<div class="col-lg-12 mt-2 text-center wow fadeInUp" data-wow-delay="600ms">
		<p class="dta1"><span style="color:#024289;">Benefits of trading with our #FaydeKeFeatures </span></p>
			<div class="bl1"></div>
		</div>
		<div class="col-lg-6  mt-2 text-center wow fadeInUp" data-wow-delay="600ms">
		<img class="img-responsive bp" alt="#FaydeKeFeatures"  src="./assets/images/landing-img/Dao2In1_1/fkf.png" data-holder-rendered="true" style="margin:0 auto;">
		</div>
		<div class="col-lg-6 mt-2 text-center">
		<div class="row">
		  <div class="col-lg-4 col-md-4 col-sm-6 text-center wow fadeInUp" data-wow-delay="700ms"> <img class="img-responsive fkficon" alt="Excel Based Trading"  src="./assets/images/landing-img/Dao2In1_1/ebt.png" data-holder-rendered="true" style="margin:0 auto;">
			<h3 class="advantagth">Excel Based
  Trading</h3>
		  </div>
		  <div class="col-lg-4 col-md-4 col-sm-6 text-center wow fadeInUp" data-wow-delay="800ms"> <img class="img-responsive fkficon" alt="Hold transfer
  releas"  src="./assets/images/landing-img/Dao2In1_1/hold.png" data-holder-rendered="true" style="margin:0 auto;">
			 <h3 class="advantagth">Hold Release
  Transfer
  </h3>
		  </div>
		  <div class="col-lg-4 col-md-4 col-sm-6 text-center wow fadeInUp" data-wow-delay="900ms"> <img class="img-responsive fkficon" alt="Theme based investments"  src="./assets/images/landing-img/Dao2In1_1/theme.png" data-holder-rendered="true" style="margin:0 auto;">
			 <h3 class="advantagth">Theme Based
  Investments</h3>
		  </div>
		  <div class="col-lg-12 col-md-12 col-sm-12 text-center  wow fadeInUp" data-wow-delay="1100ms"> 
		   <p class="advantagth" >
		   
			<a href="https://www.hdfcsec.com/fayde-ke-features" target="_blank" style="text-decoration:underline; color:#024289;"><b>Click here</b></a> to Know More
  </p>
		  </div>
		</div>
		</div>
		  
		  
		
		  
	  
		</div>
		  <a href="#dd" class="scroll-down" address="true"></a>
	  </div>
	   
  
	</section>
	
	 <section>
	  <div class="container">
	   
	  
	  
	   <div class="row">
		   <div class="col-lg-12 md-12 mt-2 text-center wow fadeInUp " data-wow-delay="700ms">
			<h2 class="dta1"><span style="color:#024289;">Features of ProTerminal</span></h2>
			<div class="bl1"></div>
			 <h4 class="bprofdta text-center"> Get free^ access to our legendary trading platform </h4>
		   </div>
			 <div class="col-lg-3 col-md-6 col-sm-6 text-center wow fadeInUp " data-wow-delay="800ms">
			  <div class=" bl1proR"></div>
			  <div class=" bl1pro1R"></div>
			  <div class="bproundR">
			  
			 <img class="img-responsive  " alt="Option Strategy"  src="./assets/images/landing-img/Dao2In1_1/pro.png" data-holder-rendered="true" style="margin:0 auto;">
			<h3 class="bproimgtxt">Option Strategy
  </h3>
  </div>
		  </div>
		   <div class="col-lg-3 col-md-6 col-sm-6 text-center wow fadeInUp  " data-wow-delay="800ms">
		   <div class=" bl1proB"></div>
			  <div class=" bl1pro1B"></div>
  <div class="bproundB">
		   <img class="img-responsive " alt="News & Sentiments"  src="./assets/images/landing-img/Dao2In1_1/pro1.png" data-holder-rendered="true" style="margin:0 auto;">
			<h3 class="bproimgtxt">News &amp; Sentiments
  </h3>
  </div>
		  </div>
		   <div class="col-lg-3 col-md-6 col-sm-6 text-center wow fadeInUp " data-wow-delay="800ms"> 
			<div class=" bl1proR"></div>
			  <div class=" bl1pro1R"></div>
		   <div class="bproundR">
		   <img class="img-responsive " alt="Advance Charts"  src="./assets/images/landing-img/Dao2In1_1/pro2.png" data-holder-rendered="true" style="margin:0 auto;">
			<h3 class="bproimgtxt"> Advance Charts</h3>
			</div>
		  </div>
		   <div class="col-lg-3 col-md-6 col-sm-6 text-center wow fadeInUp" data-wow-delay="800ms">
			<div class=" bl1proB"></div>
			  <div class=" bl1pro1B"></div>
			<div class="bproundB">
		   <img class="img-responsive " alt="Order Slicing"  src="./assets/images/landing-img/Dao2In1_1/pro3.png" data-holder-rendered="true" style="margin:0 auto;">
			<h3 class="bproimgtxt">Order Slicing</h3>
			</div>
		  </div>
		   <div class="col-lg-3 col-md-6 col-sm-6 text-center wow fadeInUp " data-wow-delay="800ms">
			<div class=" bl1proB"></div>
			  <div class=" bl1pro1B"></div>
		   <div class="bproundB">
		   <img class="img-responsive " alt="Health Score"  src="./assets/images/landing-img/Dao2In1_1/pro4.png" data-holder-rendered="true" style="margin:0 auto;">
			<h3 class="bproimgtxt">Health Score</h3>
			</div>
		  </div>
		   <div class="col-lg-3 col-md-6 col-sm-6 text-center wow fadeInUp" data-wow-delay="800ms">
			<div class=" bl1proR"></div>
			  <div class=" bl1pro1R"></div>
			<div class="bproundR">
		   <img class="img-responsive " alt="Technical Screener"  src="./assets/images/landing-img/Dao2In1_1/pro5.png" data-holder-rendered="true" style="margin:0 auto;">
			<h3 class="bproimgtxt">Technical Screener</h3>
			</div>
		  </div>
		   <div class="col-lg-3 col-md-6 col-sm-6 text-center wow fadeInUp " data-wow-delay="800ms">
			<div class=" bl1proB"></div>
			  <div class=" bl1pro1B"></div>
		   <div class="bproundB">
		   <img class="img-responsive" alt="Overview of F&O market"  src="./assets/images/landing-img/Dao2In1_1/pro6.png" data-holder-rendered="true" style="margin:0 auto;">
			<h3 class="bproimgtxt">Overview of
  F&O market</h3>
  </div>
		  </div>
		   <div class="col-lg-3 col-md-6 col-sm-6 text-center wow fadeInUp " data-wow-delay="800ms"> 
			<div class=" bl1proR"></div>
			  <div class=" bl1pro1R"></div>
		   <div class="bproundR">
		   <img class="img-responsive " alt="Radar"  src="./assets/images/landing-img/Dao2In1_1/pro7.png" data-holder-rendered="true" style="margin:0 auto;">
			<h3 class="bproimgtxt">Radar</h3>
			</div>
		  </div>
		  </div>
		  
  
	   </div>
  
	</section>
  
	
	<section >
	  <div class="container">
		<div class="row wow fadeInUp" data-wow-delay="600ms">
		  <div class="col-lg-12 mb-4 mt-2 text-center">
			<h2 class="dta1">Our Research Publications<br/>
			</h2>
			<div class="bl1"></div>
			<p class="advantagth" >
			Refer to our various research reports for industry leading actionable insights on sectors and companies.<br/>
			<b>Scan QR to read report.</b>
  
  </p>
  
		  </div>
		</div>
	  </div>
	  <div class="container">
		<div class="row mt-2 ">
		  <div class="col-lg-3 col-md-6 col-sm-12  text-center wow fadeInUp pb" data-wow-delay="600ms"> <img class="img-responsive dtimg" alt="India Equity Strategy" src="./assets/images/landing-img/Dao2In1_1/mag1.png" data-holder-rendered="true">
			<h3 class="advantagth" style="color:#024289;">India Equity Strategy:<br/>
  Atma Nirbhar Bharat</h3>
			  
			  <img class="img-responsive dtimgQR" alt="Scan QR" src="./assets/images/landing-img/Dao2In1_1/qr1.png" data-holder-rendered="true" style="width:100px;">
	  
			</div>
		  <div class="col-lg-3 col-md-6 col-sm-12  text-center wow fadeInUp pb " data-wow-delay="700ms"> <img class="img-responsive dtimg" alt="PLI: Spearheading India’s" src="./assets/images/landing-img/Dao2In1_1/mag2.png" data-holder-rendered="true">
			<h3 class="advantagth" style="color:#024289;">PLI: Spearheading India’s<br/>
  manufacturing push</h3>
				  <img class="img-responsive dtimgQR" alt="Scan QR" src="./assets/images/landing-img/Dao2In1_1/qr2.png" data-holder-rendered="true" style="width:100px;">
			</div>
		  <div class="col-lg-3 col-md-6 col-sm-12  text-center wow fadeInUp pb " data-wow-delay="800ms"> <img class="img-responsive dtimg" alt="FMCG: D2C" src="./assets/images/landing-img/Dao2In1_1/mag3.png" data-holder-rendered="true">
			<h3 class="advantagth" style="color:#024289;">FMCG: D2C - Changing<br/>
  Landscape Not Fully Factored in</h3>
				  <img class="img-responsive dtimgQR" alt="Scan QR" src="./assets/images/landing-img/Dao2In1_1/qr3.png" data-holder-rendered="true" style="width:100px;">
		   </div>
			
		  <div class="col-lg-3 col-md-6 col-sm-12 text-center wow fadeInUp " data-wow-delay="800ms">  <img class="img-responsive dtimg" alt="FinTech Playbook" src="./assets/images/landing-img/Dao2In1_1/mag4.png" data-holder-rendered="true">
			<h3 class="advantagth" style="color:#024289;">FinTech Playbook:<br/>
  Buy Now Pay Later</h3>
		   
				<img class="img-responsive dtimgQR" alt="Scan QR" src="./assets/images/landing-img/Dao2In1_1/qr4.png" data-holder-rendered="true" style="width:100px;">
			</div>
		</div>
	  </div>
	</section>
   <!-- New Invest Right app -->
   <section>
    
    <div class="container  wow fadeInUp" data-wow-delay="700ms">
      
      <div class="row">
      
        <div class="col-lg-12 col-md-12 col-sm-12 text-center wow fadeInUp vplans1" data-wow-delay="1100ms"> <img class="img-responsive" alt="Introducing our all new power packed investment app! Invest Right Scan the code,<br/>
to download the app" src="./assets/images/landing-img/Dao2In1_1/mobile.png" data-holder-rendered="true" style="margin:0 auto;width:90%;"> </div>
		
		 <div class="col-lg-12 col-md-12 col-sm-12 text-center wow fadeInUp pb mobile"  data-wow-delay="800ms">
		 
          <h3 class="mobiledownload mbline">
		  <p style="font-size:18px;margin-bottom:0px;">Introducing our all new power
packed investment app!</p>
		  	
		  </h3>
         <img class="img-responsive dtimgQR" alt="Invest Right App" src="./assets/images/landing-img/Dao2In1_1/InvestRightLogo.png" data-holder-rendered="true" style="width:80%;">
		  	<img class="img-responsive dtimgQR" alt="Scan QR Download Invest Right App now" src="./assets/images/landing-img/Dao2In1_1/download.png" data-holder-rendered="true" style="width:130px;">
			<p>Scan the code,<br/>
to download the app</p>

		  </div>
      </div>
    </div>
 
  </section>
  <!-- End New Invest Right app -->
	<!-- <section>
	  
	  <div class="container  wow fadeInUp" data-wow-delay="700ms">
		
		<div class="row">
		
		  <div class="col-lg-12 col-md-12 col-sm-12 text-center wow fadeInUp vplans1" data-wow-delay="1100ms"> <img class="img-responsive" alt="1M+ Downloads Scan QR Download Mobile App now 4 Million Happy Customers"  src="./assets/images/landing-img/Dao2In1_1/mobile.png" data-holder-rendered="true" style="margin:0 auto;width:90%;"> </div>
		  
		   <div class="col-lg-12 col-md-12 col-sm-12 text-center wow fadeInUp pb mobile" data-wow-delay="800ms" > 
			<h3 class="mobiledownload mbline" >3.5+ Million Happy Customers</h3>
		   
				<img class="img-responsive dtimgQR" alt="Scan QR Download Mobile App now" src="./assets/images/landing-img/Dao2In1_1/download.png" data-holder-rendered="true" style="width:100px;">
			  <p>Trade on the go!<br/>
  Download Mobile App now!</p>
  
			</div>
		</div>
	  </div>
   
	</section> -->
  
  </main>
  <!-- End #main --> 
  
  <!-- ======= Footer ======= -->
  <footer id="footer">
	<div class="container d-md-flex py-4 wow fadeInUp" data-wow-delay="300ms">
	  <div class="mr-md-auto text-center text-md-left">
		<div class="copyright"> <span>HDFC Securities Ltd.</span>
		  <div class="credits">
			<p> This is an information communication from HDFC bank and should not be considered as a suggestion for investment. <br/>
  The information provided here is generic in nature and for informational purposes only. It is not a substitute for specific advice in your own circumstances. You are recommended to obtain specific professional advice before you take any/refrain from any action. <br/>
  Your account shall be activated upon successful completion of Demat &amp; Trading A/c journey. <br/>
  No.1 Bank* - Based on Retail Loan book size (excluding mortgages). Source: Annual Reports FY 19-20 and No.1 on market capitalization based on BSE data as on 31 Dec, 2020 . 
   <br/>
			  <br/>
			  ^^Demat Account free for first year. *Under normal internet speed. Account would be opened after all procedure relating to IPV and client due diligence is completed. Brokerage will not exceed the SEBI prescribed limit. https://www.hdfcsec.com/digi-demat-account-open-value-plans #MTF is subject to the provisions of SEBI Circular CIR/MRD/DP/54/2017 dated June 13, 2017 and the terms and conditions mentioned in rights and obligations statement issued by HDFC Securities Ltd. ##Involvement of HDFC Securities Ltd. is restricted to Referral only. HDFC Securities Ltd. does not offer this product directly to customers <a href="https://www.hdfcsec.com/globalinvesting" target="_blank" style="color:#fff;text-decoration: underline;">https://www.hdfcsec.com/globalinvesting</a>. ^T&C. 
  <br/>
   <br/>
  **The free volume offer expires once the said free volume is exhausted or the validity expires, whichever comes first, after which the respective delivery rates mentioned will apply throughout the lifetime of the current offer. ##For Value 20 &amp; Value 25 plans: Free equity delivery volume validity is 360 days. Equity Delivery Brokerage is applicable Post Free Delivery Volume/ Delivery Volume Validity. <br/> 
  There are 2 types of Plans (applicable only for resident customers only); <br/>
  i. which is valid for a period of 360 days i.e. Lite &amp; Alpha plans, which are annual auto-renewal plans at the end of the tenure.<br/>
  ii. which comes with a validity of lifetime i.e. Value 20 &amp; Value 25 plans which is payable only once.<br/>
  Kindly note for Derivative brokerage, one should have Derivative Privilege to avail benefit.<br/>
   <br/>
			  <br/>
			  Investment in securities market are subject to market risks, read all the related documents carefully before investing.Registration granted by SEBI, membership of BASL (in case of IAs) and certification from NISM in no way guarantee performance of the intermediary or provide any assurance of returns to investors. Mutual fund investments are subject to market risks, read all scheme related documents carefully. Mutual Fund are not Exchange traded products and the Member is just acting as distributor/referral only. All disputes with respect to the distribution activity, would not have access to Exchange investor redressal forum or Arbitration mechanism.<br/>
			  <br/>
			   Please note By submitting the above mentioned details,<br/>
  1. You are authorising us to call you even though you may be registered under DNC. We shall Call/SMS you for a period of 18 months.<br/>
  2. You are opting in to receive Whatsapp communication from us on the above registered mobile number.<br/>
  <br/>
  SEBI Registration No.: INZ000186937 (NSE, BSE,MSEI, MCX) |NSE Trading Member Code: 11094 | BSE Clearing Number: 393 | MSEI Trading Member Code: 30000 | MCX Member Code: 56015 | IN-DP-372-2018 (CDSL, NSDL) | CDSL DP ID: 12086700 | NSDL DP ID: IN304279 | AMFI Reg No. ARN -13549 | PFRDA Reg. No - POP 11092018 | IRDA Corporate Agent Licence No.CA0062 | Research Analyst Reg. No. INH000002475 | Investment Adviser: INA000011538 | CIN-U67120MH2000PLC152193 Registered Address: I Think Techno Campus, Building, B, Alpha, Office Floor 8, Near Kanjurmarg Station, Kanjurmarg (East), Mumbai -400 042. Tel -022 30753400. Compliance Officer: Mr. Murli V Karkera. Ph: 022-3045 3600, Email: complianceofficer@hdfcsec.com.
  
  <br/>
		 <br/>    
  Disclaimer: HDFC Securities Ltd. is a financial services intermediary and is engaged as a distributor of financial products &amp; services like Corporate FDs &amp; Bonds, Insurance, MF, NPS,Real Estate services, Loans, NCDs, IPOs, E-Will &amp; E-Tax in strategic distribution partnerships. Customers need to check products &amp; features before investing since the contours of the product rates may change from time to time. HDFC securities Ltd. is not liable for any loss or damage of any kind arising out of investments in these products. Investments in Equity, Currency, Futures &amp; Options are subject to market risk. Clients should read the Risk Disclosure Document issued by SEBI &amp; relevant exchanges &amp; the T&amp;C on www.hdfcsec.com before investing. Global Investing, Digigold, Insurance, Mutual Funds and NPS are not an approved product of the Exchanges and any dispute related to this will not be dealt at Exchange platform. MTF is subject to the provisions of SEBI Circular CIR/MRD/DP/54/2017 dated June 13, 2017 and the terms and conditions mentioned in rights and obligations statement issued by HDFC Securities Ltd.
   <br/>
			  <br/><br/>
			 
			  <br/>
			  <!-- <a data-toggle="modal" href="#exampleModalLong" style="color:#fff;font-size:13px;text-decoration:underline;padding:0px;text-align:center;margin:0 auto;display:block;">Disclaimer</a> </p> -->
		  </div>
		</div>
	  </div>
	</div>
  </footer>
  <!-- End Footer --> 
  <!-- modal-term-condition -->
<div class="modal fade" id="modal-term-condition" data-backdrop="static" data-keyboard="false" tabindex="-1"
aria-labelledby="modal-term-condition" aria-hidden="true">
<div class="modal-dialog modal-lg modal-dialog-centered modal-dialog-scrollable">
   <div class="modal-content">
	   <div class="modal-header">
		   <h5 class="modal-title" id="exampleModalLabel">Terms & Conditions</h5>
		   <button type="button" class="close" data-dismiss="modal" aria-label="Close">
			   <span aria-hidden="true">&times;</span>
		   </button>
	   </div>
	   <div class="modal-body">
		   <h1 class="tcrg"> Demat and Trading Account Terms and Conditions </h1>
		   <div class="formcontainer">
			   <div class="row ">
				   <div class="col-lg-12 col-md-12 col-sm-12 tcpd">
					   <div class="container">
						   <h2 class="tcrgsub" style="font-family: Roboto, sans-serif;"> Hdfc Bank Demat Account Opening Terms and Conditions</h2>
						   <hr />
						   <h5 class="tcrgp"> General</h5>
						   <p>
							   1.	I hereby grant HDFC Bank Limited (the Bank) and its authorised third-party processors consent to
							   open Demat account basis the KYC details / documents & information provided by me on the HDFC Securities Ltd platform.
						   </p>
						   <p>
							   2.	I understand that, HDFC Bank may share my personal data with, regulatory agencies, law enforcement
							   agencies and fraud prevention agencies for use in verifying my identity, credit decisions,
							   regulatory requirement, legal investigation, fraud and money laundering prevention.
						   </p>
						   <p>
							   3.	I understand that, HDFC Bank will process my data for market research including statistical analysis
							   of user behaviour which the Bank may disclose to third parties in aggregated form.
						   </p>
						   <p>
							   4.	I understand that, HDFC Bank may send Newsletter or information about features, products and services, events and special offers related to their similar products and
							   services I may be entitled to or about products and services available from the Bank that may be of interest to me etc.
						   </p>
						   <p>
							   5.	I understand that, I can find a full description of what personal data the Bank collects and the purpose for collection and processing in privacy notice hosted on the Bank’s website
							   <a style=" text-transform: none;  text-decoration: underline;" href="https://www.hdfcbank.com/" target="_blank">
								   https://www.hdfcbank.com
							   </a>
						   </p>
						   <p>
							   6.	The DIS booklet will be issued to me on my request at any later date after account opening.
						   </p>
						   <p>
							   7.	I agree to avail Depository on Net Service for my account.
						   </p>
						   <p>
							   8.	I agree to receive standing instructions directly to my demat account.
						   </p>
						   <p>
							   9.	I agree that separate request will be submitted for updation of demographic details in Demat account and HSL Trading account.
						   </p>
						   <!-- <p>
							   10.	I wish to opt for Regular Demat account and not a basic service Demat account.
						   </p> -->
						   <p>
							   10.	I authorise HDFC Bank Ltd to share my details with NSDL or CDSL for the purpose of Digital Demat Account Opening.
						   </p>
						   <p>
							   11.	I agree to receive/view the Rights & Obligations & Demat Tariff in electronic form.
						   </p>
						   <p>
							   12.	I agree to the Terms & Conditions and Privacy Policy and authorize the bank to communicate with me via WhatsApp.
						   </p>
						   <p>
							   13.	CDSL A/c - To register for Easi please visit our website
							   <a style=" text-transform: none;  text-decoration: underline;" href="www.cdslindia.com" target="_blank">
								   www.cdslindia.com
							   </a> It allows a BO to view his ISIN balances, transactions and value of the portfolio online.
						   </p>
						   <p>
							   14.	NSDL A/c - To register for “SPEED-e” & “IDeAS” please visit our website
							   <a style=" text-transform: none;  text-decoration: underline;" href="https://eservices.nsdl.com/" target="_blank">
								   https://eservices.nsdl.com
							   </a> SPEED-e is a common Internet Infrastructure that enables the Depository Participants (Participants) to provide depository services to their clients. Clients can view latest balances along with the value based on the previous day closing price in their demat account using IDeAS
						   </p>


						   <hr />
						   <h5 class="tcrgp">  <b>Declaration</b> </h5>
						   <p>
							   I hereby declare that the details furnished above are true and correct
							   to the best of my knowledge and belief and I undertake to inform you of any changes therein,
							   immediately.In case any of the above information is found to be false or untrue or misleading or misrepresenting,
							   I am aware that I may be held liable for it.
						   </p>

						   <hr />
						   <h5 class="tcrgp">  <b>Email Statements</b> </h5>
						   <p>1.	I agree and consent for receiving statements in electronic mode at my registered email id. </p>

						   <p> 2.	I understand & acknowledge that HDFC Bank Limited shall not be liable or responsible for any breach of secrecy arising due to the statements being sent to my registered email ID. </p>

						   <p> 3.	I shall verify the authenticity of the emails received. I shall not hold the Bank responsible or liable for any statement received from fraudsters/imposters, if any problem arises with my computer network arising out of me receiving statements from the Bank. </p>

						   <p> 4.	I shall inform the Bank if there is any change in the email address. The Bank shall not be responsible if I do not receive statement due to incorrect email address and technical reasons.</p>

						   <p> 5.	I will take all the necessary steps to ensure confidentiality and secrecy of the login name and password of the internet/email account. </p>

						   <p> 6.	I am aware that the transaction statement may be accessed by other entities in case the confidentiality/secrecy of the login name and password is compromised. </p>


						   <hr />
						   <h5 class="tcrgp">  <b>FATCA / CRS</b></h5>
						   <p>
							   Towards compliance with tax information sharing laws, such as FATCA / CRS, I have understood the information requirements
							   as per the CBDT notified Rules 114F to 114H and hereby confirm that the information provided by me to the Bank is true, correct, and complete.
							   I understand that my personal details as provided /available in the banks records will be used for CBDT reporting. Should there be any change
							   in any information provided by me, I would update the Bank within 30 days.
						   </p>
						   <p>
							   I confirm to have read and understood the Terms & Conditions pertaining to my account.The rules and regulations of the Depository and Depository
							   Participants pertaining to an account which are in force now have been understood by me and I have understood and agree to abide by and to be bound
							   by the rules as are in force from time to time for such accounts. I hereby declare that the details furnished are true and correct to the best of
							   my knowledge and belief and I undertake to inform you of any changes therein, immediately. In case any of the above information is found to be
							   false or untrue or misleading or misrepresenting, I am aware that I may be held liable for it.
						   </p>
						   <p>
							   I specifically agree and confirm that any matter or issue arising hereunder shall be governed by and construed exclusively in accordance with
							   the Indian laws and shall be subject to the jurisdiction of the courts of Mumbai in India.
						   </p>

						   <hr />


						   <h5 class="tcrgp">  <b>Rights and Obligations of Beneficial Owner and Depository Participant as prescribed by SEBI and Depositories </b></h5>
						   <br>
						   <p>
							   <b><u>General Clause</u></b><br />
							   1. The Beneficial Owner and the Depository participant (DP) shall be bound by the provisions of the Depositories Act, 1996, SEBI (Depositories and Participants) Regulations, 1996, Rules and Regulations of Securities and Exchange Board of India(SEBI), Circulars/Notifications/Guidelines issued there under, Bye Laws and Business Rules/Operating Instructions issued by the Depositories and relevant notifications of Government Authorities as may be in force from time to time.
						   </p>
						   <p>
							   2. The DP shall open/activate Demat account of a beneficial owner in the depository system only after receipt of complete Account opening form, KYC and supporting documents as specified by SEBI from time to time.
						   </p>

						   <br>
						   <p>
							   <b><u>Beneficial Owner information</u></b>
							   <br />
							   3. The DP shall maintain all the details of the beneficial owner(s) as mentioned in the account opening form, supporting documents submitted by them and/or any other information pertaining to the beneficial owner confidentially and shall not disclose the same to any person except as required by any statutory, legal or regulatory authority in this regard.
						   </p>

						   <p>
							   4. The Beneficial Owner shall immediately notify the DP in writing, if there is any change in details provided in the account opening form as submitted to the DP at the time of opening the Demat account or furnished to the DP from time to time.
						   </p>

						   <br>
						   <p>
							   <b><u>Fees/Charges/Tariff</u></b><br />
							   5. The Beneficial Owner shall pay such charges to the DP for the purpose of holding and transfer of securities in dematerialized form and for availing depository services as may be agreed to from time to time between the DP and the Beneficial Owner as set out in the tariff Sheet provided by the DP. It may be informed to the Beneficial Owner that " no charges are payable for opening of Demat accounts
						   </p>
						   <p>
							   6. In case of Basic Services Demat Accounts, the DP shall adhere to the charge structure as laid down under the relevant SEBI and/or Depository circulars/directions/notifications issued from time to time.
						   </p>
						   <!-- <p>
							   7.In case of Basic Services Demat Accounts, the DP shall adhere to the charge structure as laid down under the relevant SEBI and/or Depository circulars/directions/notifications issued from time to time.
						   </p> -->
						   <p>
							   7. The DP shall not increase any charges/tariff agreed upon unless it has given a notice in writing of not less than thirty days to the Beneficial Owner regarding the same.
						   </p>
						   <br>

						   <p>
							   <b><u>Dematerialization</u></b><br />
							   8. The Beneficial Owner shall have the right to get the securities, which have been admitted on the Depositories, dematerialized in the form and manner laid down under the Bye Laws, Business Rules and Operating Instructions of the depositories.
						   </p>

						   <br>
						   <p>
							   <b><u>Separate Accounts</u></b><br />
							   9. The DP shall open separate accounts in the name of each of the beneficial owners and securities of each beneficial owner shall be segregated and shall not be mixed up with the securities of other beneficial owners and/or DPs own securities held in dematerialized form.
						   </p>
						   <p>
							   10. The DP shall not facilitate the Beneficial Owner to create or permit any pledge and/or hypothecation or any other interest or encumbrance over all or any of such securities submitted for dematerialization and/or held in Demat account except in the form and manner prescribed in the Depositories Act, 1996, SEBI (Depositories and Participants) Regulations, 1996, and Bye-Laws/Operating Instructions/Business Rules of the Depositories.
						   </p>

						   <br>
						   <p>
							   <b><u>Transfer of Securities</u></b><br />
							   11. The DP shall effect transfer to and from the Demat accounts of the Beneficial Owner only on the basis of an order, instruction, direction or mandate duly authorized by the Beneficial Owner and the DP shall maintain the original documents and the audit trail of such authorizations.
						   </p>
						   <p>
							   12. The Beneficial Owner reserves the right to give standing instructions with regard to the crediting of securities in his Demat account and the DP shall act according to such instructions.
						   </p>

						   <br>
						   <p>
							   <b><u> Statement of account</u></b><br />
							   13. The DP shall provide statements of accounts to the beneficial owner in such form and manner and at such time as agreed with the Beneficial Owner and as specified by SEBI/depository in this regard.
						   </p>
						   <p>
							   14. However, if there is no transaction in the Demat account, or if the balance has become Nil during the year, the DP shall send one physical statement of holding annually to such BOs and shall resume sending the transaction statement as and when there is a transaction in the account.
						   </p>
						   <p>
							   15. The DP may provide the services of issuing the statement of Demat accounts in an electronic mode if the Beneficial Owner so desires. The DP will furnish to the Beneficial Owner the statement of Demat accounts under its digital signature, as governed under the Information Technology Act, 2000. However if the DP does not have the facility of providing the statement of Demat account in the electronic mode, then the Participant shall be obliged to forward the statement of Demat accounts in physical form.
						   </p>
						   <p>
							   16. In case of Basic Services Demat Accounts, the DP shall send the transaction statements as mandated by SEBI and/or Depository from time to time.
						   </p>

						   <br>
						   <p>
							   <b><u>   Manner of Closure of Demat account </u></b><br />
							   17. The DP shall have the right to close the Demat account of the Beneficial Owner, for any reasons whatsoever, provided the DP has given a notice in writing of not less than thirty days to the Beneficial Owner as well as to the Depository. Similarly, the Beneficial Owner shall have the right to close his/her Demat account held with the DP provided no charges are payable by him/her to the DP. In such an event, the Beneficial Owner shall specify whether the balances in their Demat account should be transferred to another Demat account of the Beneficial Owner held with another DP or to rematerialize the security balances held.
						   </p>
						   <p>
							   18. Based on the instructions of the Beneficial Owner, the DP shall initiate the procedure for transferring such security balances or rematerialize such security balances within a period of thirty days as per procedure specified from time to time by the depository. Provided further, closure of Demat account shall not affect the rights, liabilities and obligations of either the Beneficial Owner or the DP and shall continue to bind the parties to their satisfactory completion.
						   </p>
						   <br>

						   <p>
							   <b><u> Default in payment of charges </u></b><br />
							   19. In event of Beneficial Owner committing a default in the payment of any amount provided in Clause 5 & 6 within a period of thirty days from the date of demand, without prejudice to the right of the DP to close the Demat account of the Beneficial Owner, the DP may charge interest at a rate as specified by the Depository from time to time for the period of such default.
						   </p>
						   <p>
							   20. In case the Beneficial Owner has failed to make the payment of any of the amounts as provided in Clause 5&6 specified above, the DP after giving two days notice to the Beneficial Owner shall have the right to stop processing of instructions of the Beneficial Owner till such time he makes the payment along with interest, if any.
						   </p>

						   <br>
						   <p>
							   <b><u> Liability of the Depository</u></b><br />

							   21. As per Section 16 of Depositories Act, 1996,
						   </p>
						   <p>
							   1. Without prejudice to the provisions of any other law for the time being in force, any loss caused to the beneficial owner due to the negligence of the depository or the participant, the depository shall indemnify such beneficial owner.
						   </p>
						   <p>
							   2. Where the loss due to the negligence of the participant under Clause (1) above, is indemnified by the depository, the depository shall have the right to recover the same from such participant.
						   </p>

						   <br>
						   <p>
							   <b><u> Freezing/ Defreezing of accounts</u></b><br />
							   22. The Beneficial Owner may exercise the right to freeze/defreeze his/her Demat account maintained with the DP in accordance with the procedure and subject to the restrictions laid down under the Bye Laws and Business Rules/Operating Instructions.
						   </p>
						   <p>
							   23. The DP or the Depository shall have the right to freeze/defreeze the accounts of the Beneficial Owners on receipt of instructions received from any regulator or court or any statutory authority.
						   </p>

						   <br>
						   <p>
							   <b><u>Redressal of Investor grievance </u></b><br />
							   24. The DP shall redress all grievances of the Beneficial Owner against the DP within a period of thirty days from the date of receipt of the complaint.
						   </p>

						   <br>
						   <p><b><u>Authorized representative</u></b></p>
						   <p>
							   25. If the Beneficial Owner is a body corporate or a legal entity, it shall, along with the account opening form, furnish to the DP, a list of officials authorized by it, who shall represent and interact on its behalf with the Participant. Any change in such list including additions, deletions or alterations thereto shall be forthwith communicated to the Participant.
						   </p>

						   <br>
						   <p>
							   <b><u>Law and Jurisdiction</u></b><br />
							   26. In addition to the specific rights set out in this document, the DP and the Beneficial owner shall be entitled to exercise any other rights which the DP or the Beneficial Owner may have under the Rules, Bye Laws and Regulations of the respective Depository in which the Demat account is opened and circulars/notices issued there under or Rules and Regulations of SEBI.
						   </p>
						   <p>
							   27. The provisions of this document shall always be subject to Government notification, any rules, regulations, guidelines and circulars/ notices issued by SEBI and Rules, Regulations and Bye-laws of the relevant Depository, where the Beneficial Owner maintains his/ her account, that may be in force from time to time.
						   </p>
						   <p>
							   28. The Beneficial Owner and the DP shall abide by the arbitration and conciliation procedure prescribed under the Bye-laws of the depository and that such procedure shall be applicable to any disputes between the DP and the Beneficial Owner.
						   </p>
						   <p>
							   29. Words and expressions which are used in this document but which are not defined herein shall unless the context otherwise requires, have the same meanings as assigned thereto in the Rules, Bye-laws and Regulations and circulars/notices issued there under by the depository and /or SEBI.
						   </p>
						   <p>
							   30. Any changes in the rights and obligations which are specified by SEBI/Depositories shall also be brought to the notice of the clients at once.
						   </p>
						   <p>
							   31. If the rights and obligations of the parties hereto are altered by virtue of change in Rules and regulations of SEBI or Bye-laws, Rules and Regulations of the relevant Depository, where the Beneficial Owner maintains his/her account, such changes shall be deemed to have been incorporated herein in modification of the rights and obligations of the parties mentioned in this document.
						   </p>

					   </div>
				   </div>



			   </div>




		   </div>
		   <div class="col-lg-12 col-md-12 col-sm-12 tcpd">
			   <hr />

			   <h5 class="tcrgp">  Additional Rights And Obligations (DDPI) </h5>
			   <P>
				   The stock broker / stock broker and depository participant shall not directly / indirectly compel the clients to execute Power of Attorney (PoA) or Demat Debit and Pledge Instruction (DDPI) or deny services to the client if the client refuses to execute PoA or DDPI.

			   </P>

			   <hr />
			   <h5 class="tcrgp">  Annexure O</h5>
			   <P>
				   Terms and Conditions for electronic instructions received from the Client by the Trading Members and/or the Participants which are authenticated by the Participant and/or Trading Member and accepted by the Client on the Depository system
			   </P>

			   <br>
			   <P>
				   <b>
					   <u>A.	The Client availing this facility shall ensure that </u>:
				   </b>
			   </P>
			   <p>
				   a.	The Client shall be required to be authenticated through remembered information along with OTP confirmation for each transaction processed through this facility. Client shall abide by such measures as may be required to ensure the safety and security of the Client’s access to and usage of electronic facility and instructions received from Trading Member and / or Participant and / or NSDL.
			   </p>
			   <p>
				   b.	The Client agrees to take adequate safety measures for accessing electronic facility, including but not limited to taking all the necessary steps to ensure confidentiality and secrecy of the Client’s remembered information and OTP received for authentication of the Client and shall not reveal the same and / or grant access to mobile number and / or email ID as recorded in demat account of the Client, to any employee, agent or official of the Trading Member or Participant or to any other person. The Client acknowledges that failure to adhere to safety and security measures prescribed by NSDL, Participant and / or the Trading Member could lead to a loss of confidentiality and secrecy of the remembered information and OTP, thereby exposing the Client to the risk of financial losses.
			   </p>
			   <p>
				   c.	The Client acknowledges that all instructions received from the Client by the Depository through this facility and processed after remembered information and OTP based authentication on Depository platform and as per the pre-trade authorization / mandate as submitted by the Client, shall be conclusive evidence of such instructions having been issued by the Client and shall be attributed to the Client. The Depository, Participant or Trading Member shall not be held liable for acting on the instructions so received.
			   </p>
			   <p>
				   d.	If the Client has reason to believe that the confidentiality of the remembered information or OTP or access to mobile number or email ID as recorded in demat account of the Client, has been compromised, the Client shall intimate the Participant [or Trading Member] forthwith about such compromise or loss. The Participant [or Trading Member] shall take best efforts to forthwith disable the Client’s access to electronic facility not later than one Working Day of receipt of such intimation from the Client. However, if any instructions are received prior to such disablement, the Depository and Participant shall not be liable for losses, if any, arising out of execution of such instructions.
			   </p>
			   <p>
				   e.	The Client further acknowledges that the Client shall not have any right to any claim against either the Participant or NSDL for losses, if any, incurred due to non-execution of such instructions received late and/or executed on a best-effort basis. In the event of any dispute relating to the date and time of receipt of the instructions on electronic facility, NSDL’s records shall be conclusive evidence and the Parties agree that NSDL’s decision on the same shall be final and binding on both Parties.
			   </p>
			   <p>
				   f.	The Client may opt out from this facility at any time by giving a notice in writing or through electronic facility to the Trading Member, Participant or Depository. The Trading member or, Participant shall terminate the service within fifteen (15) days of receipt of such notice.
			   </p>
			   <p>
				   g.	The Client agrees to indemnify, keep indemnified and hold the Participant and NSDL harmless from any loss, damage, claim, suits, legal proceedings, investigations, expenses of every kind and any other liability whatsoever, including reasonable attorney’s fees and fees of such experts as may be become necessary for NSDL, Trading Member and / or the Participant to engage, caused due to the availing of the services by the Client in any and all circumstances including without limitation, the following:
			   </p>
			   <p>
				   i)	Falsehood or misrepresentation of any nature by the Client (or any person acting on behalf of the Client)
			   </p>
			   <p>
				   ii)	Failure to use a trustworthy system for access the electronic facility;
			   </p>
			   <p>
				   iii)	Failure to take the precautions necessary to prevent the compromise, loss, disclosure, modification, or unauthorised use of the Client’s remembered information, OTP or access to mobile number and / or email ID as recorded in the demat account of the Client
			   </p>
			   <p>
				   h.	Notwithstanding anything contained herein, the Client recognises and acknowledges that the Trading member/Participant may, in accordance with instructions received by the Trading Member/Participant from NSDL, prescribe such other security measures as it deems fit, in replacement of or supplementing the validation process through the use of remembered information or OTP, including without limitation the use of biometrics and such other methods as would validate the identity of the Client for access to the electronic facility. The Client agrees that a condition precedent for the Client’s access to electronic facility is that the Client shall provide such information, data, and access to its representatives and personnel, as may be designated by the Client as the users of the electronic facility in order to enable Participant to generate such biometric criteria or other criteria in accordance with the security measures prescribed by Participant, in accordance with instructions received by the Participant from NSDL.
			   </p>

			   <br>
			   <P>
				   <b>
					   <u>B.	Participant shall take note and ensure the following </u>:
				   </b>
			   </P>
			   <p>
				   a)	The Participant may withdraw the access of the Client to electronic facility at any time provided a notice of at least thirty (30) days is given to the Client. The Participant may suspend or terminate the service without prior notice if the Client has breached any of these terms and conditions or rights and obligation of demat account, or if the Participant learns of the death, bankruptcy, lunacy or loss of legal capacity of the Client.
			   </p>
			   <p>
				   b)	This facility unless opt out by Client earlier shall be deemed to be opt out immediately on closure of demat account.
			   </p>

			   <br>
			   <P>
				   <b>
					   <u>C.	General Terms & Conditions </u>:
				   </b>
			   </P>
			   <p>
				   a.	Any dispute or difference between the Parties, other than disputes between client and Trading Member to be settled through arbitration mechanism of the concerned Stock Exchange(s) and falling beyond the scope of the Depository, shall be resolved solely by means of reference to binding arbitration under the arbitration mechanism as provided in the Bye-Laws and Business Rules.
			   </p>
			   <p>
				   b.	The above terms and conditions are in addition to and do not undermine in any manner whatsoever the terms and conditions forming a part of the rights and obligation of Participant and Client.
			   </p>
			   <br>
			   
				   <h5 class="tcrgp">Consent for Aadhaar details, email id & mobile number validation by KYC Registration Authority (KRA)</h5>
			   
			   <p>
				   1. I/We hereby provide my/our explicit consent that my/our Aadhaar record can be used by KRAfor the specific purpose of validating / maintaining / sharing my KYC record as an audit evidence. I/We understand that I/wewill have an option to request KRA for deletion of my/our Aadhaar record.
			   </p>
			   <p>
				   2. I/We hereby consent for receiving information from KRA through sms/e-mail on my/our registered mobile number/e-mail address. 
			   </p>
			   <p>
				   3. I am/We are also aware that for Aadhaar OVD based KYC, my KYC request shall be validated against Aadhaar details. I/We hereby consent for sharing my/our masked Aadhaar card with readable QR code or my Aadhaar XML/Digilocker XML file, along with passcode and as applicable, with KRA and other Intermediaries with whom I have a business relationship for KYC purposes only.
			   </p>
			   <p>
				   4. I am / We are aware that if the QR code is not readable, then the KYC shall be placed on “Hold” by KRA. Also, I/we understand that as per SEBI circular dated April 06, 2022, clients whose KYC records are not found to be valid by KRA after the validation process shall be allowed to transact in securities market only after their KYC is validated.
			   </p>
			   <br>
			   <br>


			   <h2 class="tcrgsub" style="font-family: Roboto, sans-serif;"> HDFC SECURITIES TRADING ACCOUNT OPENING TERMS AND CONDITIONS</h2>
			   <hr />
			   <br>
			   <h5 class="tcrgp"> Trading Preferences</h5>

			   <p>
				   •	I understand and agree that the nature of information I have provided for the purpose of Online Account Opening with / through HDFC SECURITIES LIMITED (hereinafter referred as “the Company”) which may be used to query my details in KRA databases as well as to fetch my information from KRA databases.
			   </p>
			   <p>
				   •	I am aware and agree that this Regular Trading account opened is for sole holders only.
			   </p>
			   <p>
				   •	I am aware and declare that I am an Ordinary Resident Individual in India.
			   </p>
			   <p>
				   •	I hereby declare that I am an Indian national
			   </p>
			   <p>
				   •	I am aware that my Trading account will be maintained and will be settled once every month for funds and securities as agreed by me
			   </p>
			   <p>
				   •	I am aware and agree that my Trading account will be opened as per the name available in the Income tax database.
			   </p>
			   <p>
				   •	I wish to avail the Margin Trading Facility (MTF) offered by the company. I am aware that terms and conditions of trading under Margin Trading Facility will be applicable to me.
			   </p>
			   <p>
				   •	I hereby consent the company to provide its communication messages to me through the medium of short messages services and / or telephone calls / or Whatsapp on my registered phone number(s) with the Company
			   </p>
			   <p>
				   •	I confirm my consent to share my email id with the RTA (Registrar and Transfer Agency)
			   </p>
			   <p>
				   •	I hereby consent to receive all statements of accounts, statements of holding, contract notes, consolidated statements, transaction statements and annual reports in electronic form from the company.
			   </p>
			   <p>
				   •	I hereby confirm to avail the SMS alert facility in my Trading account
			   </p>
			   <p>
				   •	I confirm to avail of the facility of internet trading using wireless technology.
			   </p>
			   <p>
				   •	I hereby agree that I have read, understood and acknowledge the receipt of the below documents electronically in my registered email ID with the company.
			   </p>
			   <p>
				   •	Rights and Obligations of stock broker, sub-broker and client for trading on exchanges and additional rights & obligations for internet/wireless technology based trading. (click here)
			   </p>
			   <p>
				   •	Uniform Risk Disclosure Documents (for all segments/ exchanges) (click here) Guidance Note to the client detailing Do’s and Don'ts for trading on stock exchanges. (click here)
			   </p>
			   <p>
				   •	Document describing Policies and Procedures of the stock broker
			   </p>
			   <p>
				   •	Document detailing the rate/amount of brokerage and other charges/levied (click here for Tariff Sheet)
			   </p>

			   <br>
			   <hr />
			   <h5 class="tcrgp"> Declarations</h5>
			   <p>
				   •	I declare and agree that the signature and photograph provided by me, belongs to me, for opening Trading account with HDFC Securities Limited (hereinafter referred as “the Company”).
			   </p>
			   <p>
				   •	I declare and confirm that I have received, read and understood, acknowledged and agreed to the Margin Trading Facility (MTF) Rights and Obligations as provided by HDFC Securities in PART C (click here for form) of the account opening document.
			   </p>
			   <p>
				   •	I declare that by submitting the contact details by me, I authorize HDFC Securities Limited and HDFC Bank Limited to contact me and send promotional communication, even though I may be registered under National Do Not Call Registry established under the Telecom Unsolicited Commercial Communications Regulations, 2007 or registered or may register under the National Customer Preference Register established under the new regulation viz. The Telecom Commercial Communications Customer Preference Regulations, 2010. And I don't hold the Company responsible for the aforesaid act.
			   </p>
			   <p>
				   •	I hereby declare that the details furnished are true and correct to the best of my knowledge and belief and I undertake to inform you of any changes therein, immediately. In case any of the above information is found to be false or untrue or misleading or misrepresenting, I am aware that I may be held liable for it.
			   </p>
			   <p>
				   •	I/We hereby give my/our consent to HDFC securities Ltd to share my/our KYC/Demographic details with HDFC Bank Ltd to open a Demat Account titled with  my/our name.
			   </p>
			   <br>
			   <hr />
			   <h5 class="tcrgp"> General Terms & Conditions</h5>
			   <br>
			   <p>
				   <b>• Email Statement:</b> I understand that the email statements are for my convenience. HSL shall not be liable or responsible for any breach of secrecy because the statements are being sent to the email ID registered with it. I shall verify the authenticity of the emails I receive. I shall not hold the Company responsible for any statement received from fraudsters/imposters. I shall not hold the company liable if any problem arises with my computer network because of me receiving statements from the company. The Company shall not be responsible if I/we do not receive a statement due to incorrect email address and technical reasons. I will take all the necessary steps to maintain and ensure confidentiality and secrecy of the login name and password of the internet/email account. I shall inform the Company in writing if there is any change in the email address.
			   </p>
			   <br>
			   <p>
				   <b>• Voluntary Aadhaar Consent:</b> I hereby submit voluntarily at my own discretion, the physical copy of Aadhaar card/physical e-Aadhaar / masked Aadhaar/offline electronic Aadhaar xml as issued by UIDAI (Aadhaar), to the Company, HDFC Securities Limited for the purpose of establishing my identity / address proof and voluntarily give my consent to open account / process instructions for the said purpose with the Company in my name individual capacity using my Aadhaar ; hereby consent to the Company for verification of my Aadhaar to establish its genuineness through Quick Response (QR) code embedded in the Aadhaar card or through such other acceptable manner as per UIDAI or under any Act or law from time to time. The consent and purpose of collecting Aadhaar has been explained to me in local language. The Company has informed me that myAadhaar submitted to the Company herewith shall not be used for any purpose other than mentioned above, or as per requirements of law. The Company has informed me that this consent and my Aadhaar will be stored along with my account details within the Company. I hereby declare that all the information voluntarily furnished by me is true, correct and complete. I Will not hold the Company or any of its officials responsible in case of any incorrect information provided by me/us.
			   </p>
			   <br>
			   <p>
				   <b>• FATCA:</b> I have understood the information requirements of FATCA Form as per the CBDT notified Rules 114F to 114H and hereby confirm that the information provided by me on this Form is true, correct, and complete. I also confirm that I have read and understood the Terms and Conditions below and hereby accept the same. I understand that my personal details as provided/available in the Bank/HDFC Securities’ records will be used for CBDT reporting. Further, I hereby authorize HDFC Securities Limited to furnish the above information to the bank for the purpose of compliance and reporting under CBDT Rules as applicable.
			   </p>

			   <br>
			   <br>
			   <hr />
 
		   </div>
	   </div>
   </div>
</div>
</div>
  
  <!-- <a id="back-to-top" href="#" class="btn btn-light btn-lg back-to-top top" role="button">&#8679;</a>  -->